export default __webpack_public_path__ + "static/media/down-arrow-black.f6392d79.svg";